import { ChevronDownIcon } from '@sketchnote/icons';
import { UserSelectDropDownIndicator } from '@sketchnote/shared-components';
import React from 'react';
import Select, { Styles } from 'react-select';
import {
  PropertySelectOption,
  PropertySelectSingleValue,
} from 'src/components/Elements/SelectStyles/Property';

export interface DropdownProps {
  options: any[];
  onChange?: (prop: Option) => void;
  onChangeMulti?: (prop: Option[]) => void;
  className?: string;
  placeholder?: JSX.Element | string;
  disabled?: boolean;
  value?: any;
  label?: Element | string;
  isMulti?: boolean;
}

export type Option = { label: string | number; value: any };

export const SelectStyleTwo: Styles<any, false> = {
  control: (styles) => ({
    ...styles,
    paddingTop: '6px',
    paddingBottom: '6px',
    backgroundColor: '#F6F7F9',
    paddingLeft: '2px',
    paddingRight: '21px',
    borderRadius: '6px',
    borderColor: '#E2E4E9',
    fontWeight: 400,
    fontSize: 14,
    color: '#131720',
    minHeight: '48px',
  }),

  menu: (styles) => ({
    ...styles,
    borderRadius: '6px',
    width: '100%',
    marginTop: '0.7rem',
    marginBottom: '2.3rem',
    background: '#fff',
    boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)',
  }),

  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#EEF1FC'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      paddingTop: '14px',
      paddingBottom: '10px',
      paddingLeft: '10px',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '22px',
      marginBottom: '0.5rem',
      color: isDisabled ? '#ccc' : '#131720',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
      },
    };
  },

  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};
export const SelectOption = ({
  options,
  placeholder,
  value,
  disabled,
  onChange,
  label,
  isMulti,
  onChangeMulti,
}: DropdownProps): JSX.Element => {
  return (
    <Select
      options={options}
      value={value}
      onChange={(res) => (Array.isArray(res) ? onChangeMulti?.(res) : onChange?.(res))}
      styles={SelectStyleTwo}
      placeholder={placeholder}
      menuPlacement={'auto'}
      isDisabled={disabled}
      label={label}
      isMulti={isMulti}
      components={{
        DropdownIndicator: UserSelectDropDownIndicator,
        IndicatorSeparator: () => null,
        SingleValue: PropertySelectSingleValue,
        Option: PropertySelectOption,
      }}
    />
  );
};
